import { normalizeLanguage } from '../../templates/lib/languageHelpers';

// The API keeps one template per language on a position, so a step is the run of items sharing it.
export function groupCadenceItemsIntoSteps(items = []) {
  const steps = [];
  const stepsByPosition = new Map();

  for (const item of items ?? []) {
    const position = item?.position ?? null;
    let step = position == null ? undefined : stepsByPosition.get(position);

    if (!step) {
      step = { key: position ?? `item-${item?.id}`, position, itemsByLanguage: {} };
      steps.push(step);
      if (position != null) stepsByPosition.set(position, step);
    }

    step.itemsByLanguage[normalizeLanguage(item?.template?.language)] = item;
  }

  return steps;
}
